import '../member.css'
import { useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useEffect, useState } from 'react'
import { usePostcodeSearch } from '@/hooks/usePostcodeSearch'
import { useNiceAuth } from '@/hooks/useNiceAuth'
import { GolfBizNm, GolfInfoData } from '@/pages/promotion/promotionItem'
import { SubmitHandler, useForm } from 'react-hook-form'
import commonUtils from '@/utils/commonUtils'
import { Button, Input, Select } from '@/components'
interface IFormValues {
  id: string
  password: string
  name: string
  last_name: string
}

interface PostData {
  cstId: string
  cmpnyCd: string
  joinDivCd: string
  snsId: string
  userId: string
  password: string
  password_confm?: string
  ci: string
  name: string
  nickName: string
  gender: string
  birth: string
  birthYy?: string
  birthMm?: string
  birthDd?: string
  email: string
  email1?: string
  email2?: string
  smsOptIn: string
  smsReceiveYn?: string
  hasMembership: string
  membershipBizCd?: string
  jobCd: string
  homePostCd: string
  homeAddrNum?: string
  homeAddr: string
  homeDaddr: string
  homeArCd: string
  homeExcNo: string
  homeSubNo: string
  mnc: string
  mblNo: string
  mblNetCd: string
  mblExcNo: string
  mblSubNo: string
  department: string
  jbps: string
  lastLogin: string
  accessIp: string
  pwErrCount: string
  state: string
  withDrawDttm: string
  refreshToken: string
  regId: string
  updId: string
  mblCo: string
}

const NewMember: React.FC = () => {
  const navigate = useNavigate()
  const isLogin = true
  const axios = useAxios()
  const { showAlert, showConfirm } = useDialog()
  const {
    register,
    handleSubmit,
    getValues,
    trigger,
    setFocus,
    setValue,
    formState: { errors },
  } = useForm<PostData>({
    defaultValues: {
      //default
      smsOptIn: 'Y',
      mblNo: '',
      name: '',
      birthYy: '',
      birthMm: '',
      birthDd: '',
      mblCo: '',
      hasMembership: 'N',
      membershipBizCd: '',
    },
  })
  const [postResponse, setPostResponse] = useState<any>(null)
  const [hasCheckedNickname, setHasCheckedNickname] = useState(false)
  const [hasMembership, setHasMembership] = useState<string>('N')
  const [hasCheckedId, setHasCheckedId] = useState(false)
  const { authData, requestNiceAuth } = useNiceAuth() //인증하기 hook
  const [selectedGender, setSelectedGender] = useState('')
  const [nameList, setNameList] = useState<GolfBizNm[]>([])
  const [userId, setUserId] = useState('')

  useEffect(() => {
    getMemebershipList()
  }, [])

  useEffect(() => {
    const ciUseYn = authData?.ciUseYn || ''
    if (ciUseYn === 'Y') {
      showAlert({
        type: 'warning',
        message: '이미 가입되어 있는 고객정보입니다.',
      })
      return
    } else {
      const birdt = authData?.birthdate || ''
      const gen = authData?.gender || ''
      setValue('mblNo', authData?.mobileno || '')
      setValue('name', authData?.name || '')
      setValue('birthYy', birdt.slice(0, 4))
      setValue('birthMm', birdt.slice(4, 6))
      setValue('birthDd', birdt.slice(6, 8))
      setValue('mblCo', authData?.mobileco || '')
      setValue('gender', gen)
      setSelectedGender(gen) // 남성: "1", 여성: "0"
    }
  }, [authData])

  useEffect(() => {
    const userId = 'userId'
    const password = 'password'
    const passwordConfm = 'password_confm'
    // 필드가 유효한지 확인하고 포커스를 설정
    if (document.getElementById(passwordConfm)) {
      setFocus(passwordConfm)
    }

    if (document.getElementById(password)) {
      setFocus(password)
    }

    if (document.getElementById(userId)) {
      setFocus(userId)
    }
  }, [])

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    setHasMembership(value) // state 업데이트
    setValue('hasMembership', value) // 폼 값도 업데이트

    // 폼 값이 즉시 업데이트되도록 trigger 호출
    trigger('hasMembership')

    // 회원권 없음 선택 시 membershipBizCd 초기화
    if (value === 'N') {
      setValue('membershipBizCd', '')
      trigger('membershipBizCd')
    }
  }

  //아이디중복체크
  const fnChkDupUserId = () => {
    if (getValues('userId').length < 6) {
      showAlert({
        type: 'warning',
        message: '아이디를 6자리 이상 입력해 주세요.',
      })
      return
    }
    sendGetData(getValues('userId'))
  }

  //닉네임중복체크
  const fnChkDupNickName = () => {
    if (getValues('nickName').length < 1) {
      showAlert({
        type: 'warning',
        message: '닉네임을 입력해 주세요.',
      })
      return
    }
    if (
      !getValues('nickName').trim() ||
      getValues('nickName').indexOf(' ') > -1
    ) {
      showAlert({
        type: 'warning',
        message: '닉네임에 공백을 사용할수 없습니다.',
        onClose: () => {
          setFocus('nickName')
        },
      })
      return false
    }
    sendGetData_nick(getValues('nickName'))
  }
  //자택주소검색 hook
  const { data: PostHomeData, handleOpenPopup: handleOpenPopup1 } =
    usePostcodeSearch()

  useEffect(() => {
    setValue('homePostCd', PostHomeData?.zonecode || '')
    setValue('homeAddr', PostHomeData?.address || '')
  }, [PostHomeData])

  //회원권보유CC 리스트 가져오기
  const getMemebershipList = async () => {
    try {
      const response = await axios.get(`/member/getMemebershipList`, {
        headers: { 'Cache-Control': 'no-cache' },
      })

      const { golfNameList } = response.data.data

      const seenBizCds = new Set<string>()
      const nameList: GolfBizNm[] = golfNameList
        .filter((item: GolfInfoData) => {
          const isValid = item.remark?.trim()
          const isUnique = !seenBizCds.has(item.bizCd || '')

          if (isValid && isUnique) {
            seenBizCds.add(item.bizCd || '')
            return true
          }
          return false
        })
        .map((item: GolfInfoData) => ({
          areaCd: item.areaCd?.trim(),
          bizNm: item.bizNm?.trim(),
          bizCd: item.bizCd,
        }))

      setNameList(nameList) // 골프장명리스트
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 허용할 키들 (영문, 숫자, 기본 제어키)
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'Escape',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
      'PageUp',
      'PageDown',
    ]

    const isCtrlKey = e.ctrlKey || e.metaKey
    const isControlCombination =
      isCtrlKey &&
      (e.key === 'a' ||
        e.key === 'c' ||
        e.key === 'v' ||
        e.key === 'x' ||
        e.key === 'z' ||
        e.key === 'y')

    // 허용되는 문자: 영문 대소문자, 숫자
    const isValidChar = /^[a-zA-Z0-9]$/.test(e.key)

    // 허용되지 않는 경우 입력 차단
    if (!isValidChar && !allowedKeys.includes(e.key) && !isControlCombination) {
      e.preventDefault()
      //영문으로 바꿀 때도 알럿 떠서 일단 비활성화 시킴
      // showAlert({
      //   type: 'warning',
      //   message: '영문과 숫자만 입력가능해요.',
      // })
      //return
    }
  }

  const handleInputChange = (e: any) => {
    // 영문자와 숫자만 허용
    const englishAndNumber = e.target.value.replace(/[^a-zA-Z0-9]/g, '')
    setUserId(englishAndNumber)
  }

  const selectHandler = (data: any) => {
    let selectedValue = data.target.value

    if (selectedValue === '') {
      selectedValue = ''
    }
    setValue('email2', selectedValue)
  }

  // 아이디 중복 체크 GET 요청
  const sendGetData = async (chkId: string) => {
    try {
      const tmp_data = {
        userId: chkId,
      }
      const response = await axios.get('/member/checkUserId', {
        params: { ...tmp_data },
      }) // GET 요청
      if ('N' == response.data.data.data) {
        showAlert({
          type: 'warning',
          message: '이미 사용 중인 아이디에요.',
          onClose: () => {
            setFocus('userId')
          },
        })
      } else {
        showAlert({
          type: 'success',
          message: '사용 가능한 아이디에요.',
        })
        setHasCheckedId(true) //아이디 중복 검사여부 체크
      }
    } catch (error) {
      console.error('Error during GET request:', error)
    }
  }

  // 닉네임 중복 체크 GET 요청
  const sendGetData_nick = async (chkNickName: string) => {
    try {
      const tmp_data = {
        nickName: chkNickName,
      }
      const response = await axios.get('/member/checkNickName', {
        params: { ...tmp_data },
      }) // GET 요청
      if ('N' == response.data.data.data) {
        showAlert({
          type: 'warning',
          message: '이미 사용 중인 닉네임이에요.',
          onClose: () => {
            setFocus('nickName')
          },
        })
      } else {
        showAlert({
          type: 'success',
          message: '사용 가능한 닉네임이에요.',
        })
        setHasCheckedNickname(true) // 닉네임 중복 검사여부 체크
      }
    } catch (error) {
      console.error('Error during GET request:', error)
    }
  }

  //Email입력값에 @ 포함 여부 체크
  const validateEmail = (chkEmail: any) => {
    return chkEmail.includes('@') // '@' 포함 여부 체크
  }

  const onSubmit: SubmitHandler<PostData> = (data) => {
    // 이메일 유효성 체크 후 입력값에 @포함될 경우 삭제처리
    if (validateEmail(data.email2)) {
      data.email2 = data.email2?.replace('@', '')
    }

    data.birth = (data.birthYy || '') + data.birthMm + data.birthDd

    if (data.email1 != '') {
      data.email = (data.email1 || '') + '@' + data.email2
    } else {
      data.email = ''
    }

    if ('1' == authData?.gender || '') {
      data.gender = 'M'
    } else if ('0' == authData?.gender || '') {
      data.gender = 'F'
    } else if ('' == data.gender) {
      data.gender = ''
    }

    // 회원권 보유여부 검증
    // if (!data.hasMembership || data.hasMembership === '') {
    //   showAlert({
    //     type: 'warning',
    //     message: '회원권 보유여부를 선택해 주세요.',
    //   })
    //   return
    // }

    // 회원권 보유여부 검증 - getValues로 최신 값 확인
    const currentHasMembership = getValues('hasMembership')
    if (!currentHasMembership || currentHasMembership === '') {
      showAlert({
        type: 'warning',
        message: '회원권 보유여부를 선택해 주세요.',
      })
      return
    }

    // data 객체에 최신 값 할당
    data.hasMembership = currentHasMembership

    // 회원권 보유 시 CC 선택 검증
    if (data.hasMembership === 'Y') {
      const currentMembershipBizCd = getValues('membershipBizCd')
      if (!currentMembershipBizCd || currentMembershipBizCd === '') {
        showAlert({
          type: 'warning',
          message: '회원권을 보유하신 CC를 선택해 주세요.',
          onClose: () => {
            setFocus('membershipBizCd')
          },
        })
        return
      }
      data.membershipBizCd = currentMembershipBizCd
    } else if (data.hasMembership === 'N') {
      // 회원권 없음 시 membershipBizCd 초기화
      data.membershipBizCd = ''
    }

    if (!hasCheckedId) {
      showAlert({
        type: 'warning',
        message: '아이디 중복 검사를 해 주세요.',
        onClose: () => {
          setFocus('userId')
        },
      })
      return
    }

    if (!hasCheckedNickname) {
      showAlert({
        type: 'warning',
        message: '닉네임 중복 검사를 해 주세요.',
        onClose: () => {
          setFocus('nickName')
        },
      })
      return
    }

    if (data.userId === '') {
      showAlert({
        type: 'warning',
        message: '아이디를 입력해 주세요.',
        onClose: () => {
          setFocus('userId')
        },
      })
      return
    }

    if (data.userId.length < 6) {
      showAlert({
        type: 'warning',
        message: '아이디를 6자리 이상 입력해 주세요.',
        onClose: () => {
          setFocus('userId')
        },
      })
      return
    }

    if (data.password === '') {
      showAlert({
        type: 'warning',
        message: '비밀번호를 입력해 주세요.',
        onClose: () => {
          setFocus('password')
        },
      })
      return
    }

    if (data.password_confm === '') {
      showAlert({
        type: 'warning',
        message: '비밀번호 확인을 입력해 주세요.',
        onClose: () => {
          setFocus('password_confm')
        },
      })
      return
    }

    if (data.name === '') {
      showAlert({
        type: 'warning',
        message: '인증하기 버튼을 이용하여 본인 인증을 진행해 주세요.',
        onClose: () => {
          setFocus('name')
        },
      })
      return
    }

    if (data.mblNo === '') {
      showAlert({
        type: 'warning',
        message: '인증하기 버튼을 이용하여 본인 인증을 진행해 주세요.',
        onClose: () => {
          setFocus('mblNo')
        },
      })
      return
    }

    if (data.nickName === '') {
      showAlert({
        type: 'warning',
        message: '닉네임을 입력해 주세요.',
        onClose: () => {
          setFocus('nickName')
        },
      })
      return
    }

    if (data.smsOptIn === '') {
      showAlert({
        type: 'warning',
        message: 'SMS서비스를 선택해 주세요.',
        onClose: () => {
          setFocus('smsOptIn')
        },
      })
      return
    }

    // if (data.homePostCd === '') {
    //   showAlert({
    //     type: 'warning',
    //     message: '주소 검색 버튼을 클릭하여 주소 정보를 입력해 주세요.',
    //     onClose: () => {
    //       setFocus('homePostCd')
    //     },
    //   })
    //   return
    // }

    // if (data.homeDaddr === '') {
    //   showAlert({
    //     type: 'warning',
    //     message: '상세 주소를 입력해 주세요.',
    //     onClose: () => {
    //       setFocus('homeDaddr')
    //     },
    //   })
    //   return
    // }

    // 회원권 보유 시 CC 선택 검증
    if (data.hasMembership === 'Y') {
      if (!data.membershipBizCd) {
        showAlert({
          type: 'warning',
          message: '회원권을 보유하신 CC를 선택해 주세요.',
          onClose: () => {
            setFocus('membershipBizCd')
          },
        })
        return
      }
    } else if (data.hasMembership === 'N') {
      // 회원권 없음 시 membershipBizCd 초기화
      data.membershipBizCd = ''
    }

    showConfirm({
      title: '회원 가입을 진행하시겠어요?',
      onConfirm() {
        sendPostData(data)
      },
    })
  }

  // POST 요청
  const sendPostData = async (data: PostData) => {
    try {
      const response = await axios.post('/member/insertMemberInfo', data)
      setPostResponse(response.data) // 서버에서 받은 응답을 상태에 저장

      if ('S' == response.data.data.cntResult) {
        navigate('/member/completeMember', {
          state: { data: response.data.data.userName },
        })
      } else {
        showAlert({
          title: '회원 가입에 실패했어요.',
        })
      }
    } catch (error) {
      showAlert({
        title: '회원 가입에 실패했어요.',
      })
      console.error('Error during POST request:', error)
    }
    window.scrollTo(0, 0)
  }

  const buttonHandler = (pathName: string) => {
    if (isLogin) {
      switch (pathName) {
        case 'complete':
          return
        case 'cancle':
          return navigate('/main')
        default:
          return navigate('/member')
      }
    }
  }

  return (
    <div className="member-container">
      <div className="member-form-wrapper">
        <header className="member-form-header">
          <h1>회원 가입</h1>
          <div className="member-required-notice">* 필수입력사항</div>
        </header>
        <form action="#" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Input
            type="hidden"
            {...register('mblCo')}
            id="mblCo"
            name="mblCo"
            value=""
          />
          <div className="member-signup-form">
            {/* 아이디 */}
            <div className="member-form-group" style={{ marginBottom: '0px' }}>
              <label htmlFor="userId" className="member-label member-required">
                아이디
              </label>
              <div className="member-input-group">
                <Input
                  {...register('userId')}
                  id="userId"
                  name="userId"
                  type="text"
                  placeholder="아이디를 입력해 주세요."
                  maxLength={14}
                  minLength={6}
                  value={userId}
                  onKeyDown={handleKeyDown}
                  onChange={handleInputChange}
                />
                <button
                  type="button"
                  className="member-btn-check"
                  onClick={fnChkDupUserId}
                >
                  중복확인
                </button>
              </div>
            </div>
            <div className="member-help-text">
              * 영문(대/소문자구분), 숫자 조합 6~14자로 입력해 주세요.
            </div>
            <div style={{ marginBottom: '25px' }} />

            {/* 비밀번호 */}
            <div className="member-form-group">
              <label
                htmlFor="password"
                className="member-label member-required"
              >
                비밀번호
              </label>
              <Input
                {...register('password')}
                id="password"
                name="password"
                type="password"
                placeholder="비밀번호를 입력해 주세요."
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, '')
                }}
              />
            </div>

            {/* 비밀번호 확인 */}
            <div className="member-form-group">
              <label
                htmlFor="password_confm"
                className="member-label member-required"
              >
                비밀번호 확인
              </label>
              <Input
                {...register('password_confm', {
                  validate: (value) =>
                    value === getValues('password') ||
                    '비밀번호가 일치하지 않습니다.',
                  onBlur: () => trigger('password_confm'),
                })}
                id="password_confm"
                name="password_confm"
                type="password"
                placeholder="비밀번호를 한번 더 입력해 주세요."
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, '')
                }}
                feedbackText={errors?.password_confm?.message} // 에러 메시지 처리
                state={
                  commonUtils.hasKey(errors, 'password_confm')
                    ? 'error'
                    : 'success'
                } // 상태 처리
                showState={!!commonUtils.hasKey(errors, 'password_confm')} // 상태 노출 여부
              />
            </div>

            {/* 이름 */}
            <div className="member-form-group" style={{ marginBottom: '0px' }}>
              <label htmlFor="name" className="member-label member-required">
                이름
              </label>
              <div className="member-input-group">
                <Input
                  {...register('name')}
                  id="name"
                  name="name"
                  type="text"
                  onClick={requestNiceAuth}
                  placeholder="인증하기 버튼을 클릭해 주세요."
                  readOnly
                />
                <button
                  type="button"
                  className="member-btn-check"
                  onClick={requestNiceAuth}
                >
                  인증하기
                </button>
              </div>
            </div>
            <div className="member-warning-text">
              * 인증하기 버튼을 클릭하면 본인 인증을 진행해 주세요.
              <br />
              이름, 휴대폰 번호, 상명, 생년월일은 본인 인증 결과로 기반으로
              입력됩니다.
            </div>
            <div style={{ marginBottom: '25px' }} />
            {/* 휴대폰 */}
            <div className="member-form-group">
              <label htmlFor="mblNo" className="member-label member-required">
                휴대폰
              </label>
              <Input
                {...register('mblNo')}
                readOnly
                id="mblNo"
                name="mblNo"
                type="text"
                placeholder="인증하기 버튼을 클릭해 주세요."
                onClick={requestNiceAuth}
              />
            </div>

            {/* 성별 */}
            <div className="member-form-group">
              <label htmlFor="gender" className="member-label member-required">
                성별
              </label>
              <div
                style={{
                  width: '20%',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <input
                      type="radio"
                      id="radio1"
                      value={'1'}
                      disabled
                      checked={selectedGender === '1'}
                      {...register('gender')}
                    />
                    남성
                  </label>
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <input
                      type="radio"
                      id="radio2"
                      value={'2'}
                      checked={selectedGender === '0'}
                      disabled
                      {...register('gender')}
                    />
                    여성
                  </label>
                </div>
              </div>
            </div>

            {/* 생년월일 */}
            <div className="member-form-group">
              <label htmlFor="birth" className="member-label member-required">
                생년월일
              </label>
              <div className="member-date-group">
                <Input
                  {...register('birthYy')}
                  id="birthYy"
                  name="birthYy"
                  readOnly
                />
                <span className="member-date-separator">년</span>
                <Input
                  {...register('birthMm')}
                  id="birthMm"
                  name="birthMm"
                  readOnly
                />
                <span className="member-date-separator">월</span>
                <Input
                  {...register('birthDd')}
                  id="birthDd"
                  name="birthDd"
                  readOnly
                />
                <span className="member-date-separator">일</span>
              </div>
            </div>

            {/* 닉네임 */}
            <div className="member-form-group">
              <label
                htmlFor="nickName"
                className="member-label member-required"
              >
                닉네임
              </label>
              <div className="member-input-group">
                <input
                  {...register('nickName')}
                  id="nickName"
                  name="nickName"
                  type="text"
                  placeholder="닉네임을 입력해 주세요."
                  maxLength={20}
                />
                <button
                  type="button"
                  className="member-btn-check"
                  onClick={fnChkDupNickName}
                >
                  중복확인
                </button>
              </div>
            </div>

            {/* SMS/수신설정 */}
            <div className="member-form-group member-checkbox-group">
              <div className="member-checkbox-item">
                <label
                  htmlFor="radio3"
                  className="member-label member-required"
                >
                  SMS/수신설정동의
                </label>
              </div>
              <div style={{ display: 'flex', gap: '20px' }}>
                <label
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <input
                    type="radio"
                    id="radio4"
                    value={'Y'}
                    {...register('smsOptIn')}
                  />
                  수신할게요
                </label>
                <label
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <input
                    type="radio"
                    id="radio5"
                    value={'N'}
                    {...register('smsOptIn')}
                  />
                  거부할게요
                </label>
              </div>
            </div>

            {/* 회원급수 */}
            <div className="member-form-group">
              <label htmlFor="radio6" className="member-label member-required">
                회원권 보유 여부
              </label>
              <div style={{ display: 'flex', height: '38px' }}>
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginRight: '20px',
                  }}
                >
                  <input
                    type="radio"
                    id="radio6"
                    value={'Y'}
                    {...register('hasMembership')}
                    onChange={handleRadioChange}
                    checked={hasMembership === 'Y'} // checked 속성 추가
                  />
                  있음
                </label>
                {hasMembership === 'Y' && (
                  <div>
                    <Select
                      {...register('membershipBizCd')}
                      id="membershipBizCd"
                      name="membershipBizCd"
                      width="400px"
                      onChange={(e) => {
                        setValue('membershipBizCd', e.target.value)
                      }}
                      style={{
                        width: '250px',
                        marginRight: '20px',
                      }}
                    >
                      <option value="">선택하세요.</option>
                      {nameList.map((option, index) => (
                        <option
                          key={`${option.areaCd}-${index}`}
                          value={option.bizCd}
                        >
                          {option.bizNm}
                        </option>
                      ))}
                    </Select>
                  </div>
                )}
                <label
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <input
                    type="radio"
                    id="radio7"
                    value={'N'}
                    {...register('hasMembership')}
                    onChange={handleRadioChange}
                    checked={hasMembership === 'N'} // checked 속성 추가
                  />
                  없음
                </label>
              </div>
            </div>

            {/* 자택 주소 */}
            <div className="member-form-group">
              <label htmlFor="homePostCd" className="member-label">
                자택 주소
              </label>
              <div className="member-address-group">
                <div className="member-address-row">
                  <Input
                    {...register('homePostCd')}
                    id="homePostCd"
                    name="homePostCd"
                    placeholder="우편번호"
                    onClick={handleOpenPopup1}
                    readOnly
                  />
                  <button
                    type="button"
                    className="member-btn-search"
                    onClick={handleOpenPopup1}
                  >
                    주소검색
                  </button>
                </div>
                <div className="member-address-row">
                  <Input
                    {...register('homeAddr')}
                    placeholder="기본주소"
                    id="homeAddr"
                    name="homeAddr"
                    disabled
                  />
                  <Input
                    {...register('homeDaddr')}
                    placeholder="상세주소"
                    id="homeDaddr"
                    name="homeDaddr"
                  />
                </div>
              </div>
            </div>

            {/* 이메일 */}
            <div className="member-form-group">
              <label htmlFor="email1" className="member-label">
                이메일
              </label>
              <div className="member-email-group">
                <Input {...register('email1')} id="email1" name="email1" />
                <span className="member-email-separator">&nbsp;@&nbsp;</span>
                <Input {...register('email2')} id="email2" name="email2" />
                <Select
                  className="member-domain-select"
                  id="selEmail"
                  name="selEmail"
                  onChange={selectHandler}
                >
                  <option value="">직접입력</option>
                  <option value="naver.com">naver.com</option>
                  <option value="gmail.com">gmail.com</option>
                  <option value="hanmail.net">hanmail.net</option>
                  <option value="kakao.com">kakao.com</option>
                  <option value="daum.net">daum.net</option>
                  <option value="hotmail.com">hotmail.com</option>
                  <option value="yahoo.co.kr">yahoo.co.kr</option>
                </Select>
              </div>
            </div>

            {/* 직업 */}
            <div className="member-form-group">
              <label htmlFor="jobCd" className="member-label">
                직업
              </label>
              <Select {...register('jobCd')} id="jobCd" name="jobCd">
                <option value="">직업을 선택해 주세요</option>
                <option value="01">교육</option>
                <option value="02">연구개발</option>
                <option value="03">법률</option>
                <option value="04">회계/세무</option>
                <option value="05">숙박/음식</option>
                <option value="06">오락/문화/스포츠</option>
                <option value="07">통신</option>
                <option value="08">운송/물류</option>
                <option value="09">건설</option>
                <option value="10">농업/임업/광업/수산업</option>
                <option value="11">방송/언론/광고</option>
                <option value="12">유통/무역</option>
                <option value="13">의약</option>
                <option value="14">의료기기</option>
                <option value="15">개인병원</option>
                <option value="16">종합병원</option>
                <option value="17">자영업</option>
                <option value="18">정부</option>
                <option value="19">비영리/사회복지/행정</option>
                <option value="20">제1금융</option>
                <option value="21">제2금융</option>
                <option value="22">제조업1(금속/제철)</option>
                <option value="23">제조업2(의복/섬유/목재)</option>
                <option value="24">제조업3(석유/화학/전기)</option>
                <option value="25">컴퓨터/인터넷</option>
                <option value="26">골프업계</option>
                <option value="27">무직</option>
                <option value="99">기타</option>
              </Select>
            </div>

            {/* 버튼 그룹 */}
            <div className="member-button-group">
              <button
                type="submit"
                className="member-btn-submit"
                onClick={() => {
                  if (errors?.password_confm) {
                    showAlert({
                      type: 'warning',
                      message: '비밀번호가 일치하지 않아요.',
                      onClose: () => {
                        setFocus('password_confm')
                      },
                    })
                    return
                  }
                }}
              >
                가입하기
              </button>
              <button
                type="button"
                className="member-btn-cancel"
                onClick={() => buttonHandler('cancle')}
              >
                취소
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default NewMember
